import ApiService from "@/components/utils/api.service.js"
import { Swal } from "@/components/utils/swal.alerts.js";
import i18n from "@/i18n.js";

// Cache for constance config
const constanceConfigCache = {
    data: null,
    timestamp: null,
    ttl: 60 * 60 * 1000 // 1 hour in milliseconds
};

export default {
    getCountryPluginData: function() {
        return ApiService
            .get("/api/v1/country-plugin-data")
            .then(response => {
                return response;
            })
    },
    getConstanceConfig: function() {
        // Check if we have cached data and it's still valid
        const now = Date.now();
        if (constanceConfigCache.data && constanceConfigCache.timestamp && 
            (now - constanceConfigCache.timestamp) < constanceConfigCache.ttl) {
            return Promise.resolve(constanceConfigCache.data);
        }

        // If no valid cache, fetch from API
        return ApiService
            .get("/api/v1/constance-config")
            .then(response => {
                // Cache the response
                constanceConfigCache.data = response;
                constanceConfigCache.timestamp = now;
                return response;
            })
    },
    getGursSessionId: function() {
        return ApiService
            .get("/api/v1/gurs-session-id")
            .then(response => {
                return response.data;
            })
    },
    getWeDocs: function(key) {
        return ApiService
            .get("/documentation/help/" + key)
            .then(response => {
                return response;
            })
    },

    getRealEstateData: function(re_key) {
        return ApiService
            .get(`/amas/real-estate/api/real-estate/${re_key}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                if(error.response && error.response.status===404) {
                    Swal({   
                        title: i18n.t("general:warning"),
                        text: `${i18n.t("real_estate:invalid_re_key:error")}: '${re_key}'`,
                        icon: "warning"
                    })
                    return null;
                } else {
                    throw error;
                }
            })
    },
    getRealEstateGeometry: function(re_key) {
        return ApiService
            .get(`/amas/real-estate/api/real-estate/${re_key}/geometry`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                if(error.response && error.response.status===404) {
                    Swal({   
                        title: i18n.t("general:warning"),
                        text: `${i18n.t("real_estate:invalid_re_key:error")}: '${re_key}'`,
                        icon: "warning",
                        confirmButtonText: i18n.t("general:ok")
                    })
                } else {
                    throw error;
                }
            })
    },

    getLegalStatus: function(re_key, ignore_cache=false, force_new=false) {
        return ApiService
            .get(`/amas/analysis/legal/api/${re_key}`, {
                params: {
                    ignore_cache: ignore_cache,
                    force_new: force_new
                }
            })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                throw error;
            })
    },

    getParcelsByGps: function(lat, lng) {
        /*
        Returns a Parcel objects containing {lat, lng} gps point
        */
        return ApiService
            .get("/amas/real-estate/api/geosearch/parcels", {
                params: {
                    geom: { "type": "Point", "coordinates": [lng, lat] },
                    lookup: "ST_Contains"
                }
            })
            .then(response => {
                return response.data;
            })
    },
    
    getParcelsByGpsFromOSS: function(lat, lng) {
        /*
        Returns a Parcel objects containing {lat, lng} gps point
        */
        return ApiService
            .get("/amas/real-estate/api/geosearch/parcels_oss", {
                params: {
                    lat: lat,
                    lng: lng,
                }
            })
            .then(response => {
                return response.data;
            })
    },

    getValuationSubjectEstimation: function(re_key) {
        /*
        For provided 're_key', return estimation of a valuation subject.
        */
        return ApiService
            .get(`/amas/real-estate/api/valuation-subject-estimate/${re_key}`)
            .then(response => {
                return response.data;
            })
    },

    getFunctionalWhole: function(...re_keys) {
        /*
        For provided 're_keys', return functional whole analysis - neighboring parcels and their ownership.
        */
        const re_keys_param = re_keys.join(',');
        return ApiService
            .get(`/amas/real-estate/api/functional-whole`, {
                params: {
                    re_keys: re_keys_param
                }
            })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                if(error.response && error.response.status===400) {
                    Swal({   
                        title: i18n.t("general:warning"),
                        text: error.response.data.error || i18n.t("general:error"),
                        icon: "warning",
                        confirmButtonText: i18n.t("general:ok")
                    })
                    return null;
                } else {
                    throw error;
                }
            })
    },
}
